import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getJahisNsipsMismatches } from '../../../../apis/jahisNsipsMatching'
import { GlobalState } from '../../../../stores/reducer'
import { queryKeys } from '../../../../shared'

/**
 * JAHIS-NSIPS不一致詳細を取得する Query hook
 *
 * 指定期間の不一致処方箋リストを取得する。
 * フィールド指定で特定の不一致のみをフィルタ可能。
 *
 * @param startDate - 開始日（YYYY-MM-DD）
 * @param endDate - 終了日（YYYY-MM-DD）
 * @param field - フィールド名（省略時は全フィールド）
 * @param pharmacyId - 薬局ID（本部アカウントのみ指定可能）
 */
export const useJahisNsipsMismatchesQuery = (
  startDate: string | undefined,
  endDate: string | undefined,
  field?: string,
  pharmacyId?: string
) => {
  const isLoggedIn = useSelector((state: GlobalState) => state.isLoggedIn)

  return useQuery({
    queryKey: queryKeys.jahisNsipsMatching.mismatches(
      startDate || '',
      endDate || '',
      field,
      pharmacyId
    ),
    queryFn: async () => {
      const { data } = await getJahisNsipsMismatches({
        start_date: startDate!,
        end_date: endDate!,
        field,
        ...(pharmacyId ? { pharmacy_id: pharmacyId } : {}),
      })
      return data
    },
    enabled: isLoggedIn && !!startDate && !!endDate,
    staleTime: 5 * 60 * 1000, // 5分間キャッシュを有効に
  })
}
